export default __webpack_public_path__ + "static/media/testimony_student_two.ee68d6e1.png";